module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newalbum":"New album","share":"Invite user"},"fr":{"newalbum":"Nouvel album","share":"Inviter un utilisateur"}}')
  delete Component.options._Ctor
}
